import ContactsBaseDetailsPageController from './base';

export default class ContactsDetailsDocumentsPageController extends ContactsBaseDetailsPageController {

}



// WEBPACK FOOTER //
// ./src/app/modules/contacts/controllers/pages/details/documents.js